<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`新增检测依据`"
    width="600px"
    height="400px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="检测项目" prop="testItem">
            <el-select v-model="editForm.testItem" placeholder="请选择">
              <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemName" :value="item.itemId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标准号" prop="basisCode">
            <el-input v-model.trim="editForm.basisCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测依据名称" prop="basisName">
            <el-input type="textarea" v-model="editForm.basisName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="关联文件" prop="fileList" ref="fileFormItem">
            <UploadButton
              v-model="editForm.fileList"
              :limit="1"
              :fileType="['doc', 'docx', 'pdf']"
              :paramsData="{ type: 'upt_basis' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import UploadButton from '@/components/UploadArea/UploadButton';

import { editBasis, getItem, editItem } from '@/api/system';

export default {
  components: { UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    itemList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: { fileList: [] },
      rules: {
        testItem: [{ required: true, message: '请选择检测项目', trigger: 'change' }],
        basisCode: [{ required: true, message: '请输入检标准号', trigger: 'blur' }],
        basisName: [{ required: true, message: '请输入样品名称检测依据名称', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const fileId = this.editForm.fileList?.[0]?.fileId ?? null;
          const params = {
            id: this.editForm.id ?? null,
            basisCode: this.editForm.basisCode,
            basisName: this.editForm.basisName,
            fileId
          };

          try {
            const { data: newBaisId } = await editBasis(params);

            // 添加依据成功后，在检测项目添加该依据
            const { data: itemData } = await getItem({ id: this.editForm.testItem });
            const oldBasisList =
              itemData?.basisList.map(item => {
                return {
                  basisId: item.basisId
                };
              }) ?? [];
            const editItemParams = {
              ...itemData,
              basisList: [...oldBasisList, { basisId: newBaisId }]
            };
            await editItem(editItemParams);
            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
